import { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { ShareObjectForm } from "./ShareObjectForm";
import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import { useShareObjectModal } from "./hook/use-share-object-modal";
import { PermissionModalHeader } from "./PermissionModalHeader";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectSharedObjectById } from "../../../../app/state/storageObjectSlice/selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  service: StorageScope;
  closeModal: (id: TModalsIds) => void;
}

export const ShareObjectModal = ({ service, closeModal }: Props) => {
  const shareModal = useModalSelectors("share_object_modal");
  const sharedObjects = useAppSelector((state) =>
    selectSharedObjectById(state, shareModal.info?.id ?? ""),
  );
  const {
    permissions,
    handleChangeFields,
    handleDeletePermission,
    handleDeleteAccessBlock,
    handleAddNewPermissionBlock,
    handleSubmit,
  } = useShareObjectModal(service, shareModal.info?.id ?? "", sharedObjects);
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={shareModal.isOpen}
      onClose={() => closeModal("share_object_modal")}
      closeModal={() => closeModal("share_object_modal")}
      buttonOkText={t("common.confirm_button")}
      onOk={() => {
        handleSubmit();
        closeModal("share_object_modal");
      }}
      onCancel={() => {
        closeModal("share_object_modal");
      }}
      onCancelText={"Закрыть"}
      hasFooter
    >
      <div className={styles["body"]}>
        <PermissionModalHeader
          addNewPermissionBlock={handleAddNewPermissionBlock}
        />
        <div className={styles["permissions-block"]}>
          {permissions.map((permission, index) => (
            <ShareObjectForm
              key={permission.id}
              permissions={permission}
              handleRevokeAccess={handleDeletePermission}
              handleChangeFields={handleChangeFields}
              handleDeleteAccessBlock={handleDeleteAccessBlock}
              hasDeleteBlockButton={index !== 0}
            />
          ))}
        </div>
      </div>
    </ModalBasic>
  );
};
